/** @format */

import {ALL_CHART_IDS} from '../../../constants/allChartIds';
import {AnalyticGoalFromQuery} from '../../../models/api';
import {ChartIds} from '../../../models/chartIds';
import {Space} from '../../../models/spaces';

const isCrId = (id: ChartIds) => String(id).startsWith('funnel_cr_');

const pruneMissingFunnelWidgets = (
  space: Space,
  analyticGoals: ReadonlyArray<AnalyticGoalFromQuery>,
): Space => {
  const allowedIds = new Set<ChartIds>([
    ...ALL_CHART_IDS,
    ...analyticGoals.map(g => g.name as ChartIds),
    ...(Object.keys(space.widgetsSettings) as ChartIds[]),
  ]);

  const filterId = (id: ChartIds) => allowedIds.has(id) || isCrId(id);

  const widgetsBoardSelected = space.widgetsBoardSelected.filter(filterId);
  const widgetsMenuSelected = space.widgetsMenuSelected.filter(filterId);
  const chartSelectedCurrent = space.chartSelected.current.filter(filterId);
  const chartSelectedPrevious = space.chartSelected.previous.filter(filterId);

  const nextSettingsEntries = Object.entries(space.widgetsSettings).filter(([key]) =>
    filterId(key as ChartIds),
  ) as [ChartIds, Space['widgetsSettings'][ChartIds]][];
  const widgetsSettings = Object.fromEntries(nextSettingsEntries) as Space['widgetsSettings'];

  const changed =
    widgetsBoardSelected.length !== space.widgetsBoardSelected.length ||
    widgetsMenuSelected.length !== space.widgetsMenuSelected.length ||
    chartSelectedCurrent.length !== space.chartSelected.current.length ||
    chartSelectedPrevious.length !== space.chartSelected.previous.length ||
    Object.keys(widgetsSettings).length !== Object.keys(space.widgetsSettings).length;

  if (!changed) return space;

  return {
    ...space,
    widgetsBoardSelected,
    widgetsMenuSelected,
    chartSelected: {
      current: chartSelectedCurrent,
      previous: chartSelectedPrevious,
    },
    widgetsSettings,
  };
};

export default pruneMissingFunnelWidgets;
